export default "__VITE_ASSET__BM$lNndp__"